// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ArbitrationDTO } from './arbitration-dto';
import { CheckoutWithTenancyDTO } from './checkout-with-tenancy-dto';
import { ClaimDocumentDTO } from './claim-document-dto';
import { ClaimItemDTO } from './claim-item-dto';
import { ClaimProposalDTO } from './claim-proposal-dto';
import { ClaimRespondentDTO } from './claim-respondent-dto';
import { ClaimResponseDocumentDTO } from './claim-response-document-dto';
import { ClaimStatusDTO } from './claim-status-dto';
import { EvidenceChaserDTO } from './evidence-chaser-dto';
import { OrderWithOrderCustomersDTO } from './order-with-order-customers-dto';
import { OrganizationDTO } from './organization-dto';
import { TenancyAccessMode } from './tenancy-access-mode';
import { UserDTO } from './user-dto';

/**
 * 
 * @export
 * @interface ClaimWithCheckoutRelationsDTO
 */
export interface ClaimWithCheckoutRelationsDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    id: string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    organization: OrganizationDTO;
    /**
     * 
     * @type {TenancyAccessMode}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    accessMode?: TenancyAccessMode;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    status: ClaimWithCheckoutRelationsDTOStatusEnum;
    /**
     * 
     * @type {Array<ClaimStatusDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    statuses: Array<ClaimStatusDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    repositMessage?: string;
    /**
     * 
     * @type {Array<ClaimRespondentDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    respondents: Array<ClaimRespondentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    repositMessagePublishedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    agentResponse?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    tenantDisputeMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    agentResponsePublishedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    originalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    finalAmount?: number;
    /**
     * 
     * @type {Array<ClaimItemDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    items: Array<ClaimItemDTO>;
    /**
     * 
     * @type {Array<ClaimDocumentDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    documents: Array<ClaimDocumentDTO>;
    /**
     * 
     * @type {Array<ClaimResponseDocumentDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    responseDocuments: Array<ClaimResponseDocumentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    publishedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    supplierPaidAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    substantiationDeadline?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    bankTransactionsEnabledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    createdByUserId: string;
    /**
     * 
     * @type {UserDTO}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    createdByUser: UserDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    autoChargeEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    legacyId?: string;
    /**
     * 
     * @type {ArbitrationDTO}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    arbitration?: ArbitrationDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    mediationEnabled: boolean;
    /**
     * 
     * @type {Array<ClaimProposalDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    proposals: Array<ClaimProposalDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    adjudicationFeeOrderId?: string;
    /**
     * 
     * @type {OrderWithOrderCustomersDTO}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    adjudicationFeeOrder?: OrderWithOrderCustomersDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    disputeFeeWaived: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    adjudicationDocumentationGeneratedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    adjudicationSentAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    adjudicationOutcomeExpectedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    insuranceDatesSetAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    insuranceSentAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    insuranceOutcomeExpectedAt?: string;
    /**
     * 
     * @type {Array<EvidenceChaserDTO>}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    evidenceChasers?: Array<EvidenceChaserDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    resolvedForSupplierAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    evidenceChaserSkippedAt?: string;
    /**
     * 
     * @type {CheckoutWithTenancyDTO}
     * @memberof ClaimWithCheckoutRelationsDTO
     */
    checkout: CheckoutWithTenancyDTO;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimWithCheckoutRelationsDTOStatusEnum {
    DRAFT = 'DRAFT',
    AWAITINGREVIEW = 'AWAITING_REVIEW',
    DEACTIVATED = 'DEACTIVATED',
    AWAITINGRESPONDENTS = 'AWAITING_RESPONDENTS',
    MEDIATION = 'MEDIATION',
    AWAITINGARBITRATIONADMINFEE = 'AWAITING_ARBITRATION_ADMIN_FEE',
    AWAITINGARBITRATION = 'AWAITING_ARBITRATION',
    ARBITRATED = 'ARBITRATED',
    RESOLVED = 'RESOLVED',
    AWAITINGSUBSTANTIATION = 'AWAITING_SUBSTANTIATION',
    AWAITINGEVIDENCEREVIEW = 'AWAITING_EVIDENCE_REVIEW',
    EVIDENCEREVIEW = 'EVIDENCE_REVIEW',
    AWAITINGADDITIONALINFORMATION = 'AWAITING_ADDITIONAL_INFORMATION',
    DECLINED = 'DECLINED',
    AWAITINGPAYOUT = 'AWAITING_PAYOUT',
    ARBITRATION = 'ARBITRATION',
    INSURANCECLAIM = 'INSURANCE_CLAIM'
}



